import React from 'react'
import PropTypes from 'prop-types'
import { getInfo } from '@deseretbook/cms'
import { styled } from '@deseretbook/react-ui'
import { ContentBlock, EmbeddedContent, Images } from './'
import { DeseretBookCMS } from '../../dbcom'

const StyledSlices = styled('div')(({ theme }) => ({
  label: 'Slices',
  '> * + *': {
    marginTop: theme.spacing.use(1),
  },
}))

/**
 * Generic prismic slices component.
 *
 * @returns {function} Component
 */
const Slices = ({ slices, user }) => (
  <StyledSlices>
    {slices.map((slice, idx) => {
      const { type } = getInfo(slice)

      let Component

      switch (type) {
        case 'content block':
          Component = ContentBlock
          break
        case 'embedded content':
          Component = EmbeddedContent
          break
        case 'images':
          Component = Images
          break
        default:
          return null
      }

      // All we have is the index, so we have to use that as the key.
      return (
        /* eslint-disable-next-line react/no-array-index-key */
        <div key={idx}>
          <Component slice={slice} cms={DeseretBookCMS} user={user} />
        </div>
      )
    })}
  </StyledSlices>
)

Slices.propTypes = {
  slices: PropTypes.arrayOf(PropTypes.shape),
  user: PropTypes.shape({
    id: PropTypes.number,
  }),
}

Slices.defaultProps = {
  slices: [],
  user: {},
}

export default Slices
